'use strict';
import angular from 'angular';
import ngMaterial from 'angular-material';
import { RemoveItemsDialogComponent } from './remove-items-dialog/remove-items-dialog.component';
import ShippingOptionsController from './shipping-options.controller';
import ShippingAddressForm from '../forms/account/shipping-address';
import AdjustmentIntership from '../adjustment-intership';
import DeliveryOptions from './delivery-options';
import CartService from '../../app/cart/cart.service';
import ModalPopupService from './modal-popup.service';
import ShippingOptionsService from './shipping-options.service';
import ExistingAddresses from '../existing-addresses';
import giftCardBalance from '../giftCardBalance';
import newShippingAddress from './new-shipping-address';
export default angular.module('directives.shippingOptions', [
    ngMaterial,
    ShippingAddressForm,
    AdjustmentIntership,
    ExistingAddresses,
    DeliveryOptions,
    giftCardBalance,
    newShippingAddress,
    'dialog',
    'tooltip',
])
    .controller('ShippingOptionsController', ShippingOptionsController)
    .service('ShippingOptionsService', ShippingOptionsService)
    .service('CartService', CartService)
    .service('ModalPopupService', ModalPopupService)
    .component('shippingOptions', {
    template: require('./shipping-options.html'),
    controller: ShippingOptionsController
})
    .component('removeItemsDialog', RemoveItemsDialogComponent)
    .name;
//# sourceMappingURL=index.js.map